/* @flow */

import { CSSTransition, Transition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { mapValues } from 'lodash/fp';
import * as React from 'react';

import { withMediaType } from '@sonyged/ext-proc';

import type { StoreState } from '../../../redux/types';

type BubbleProps = {
  scale: number,
  mediaType: 'mobile' | 'smallPC' | 'largePC',
  children: React.Node,
};

const StaffTalkBubble = withMediaType(({ children, scale, mediaType }: BubbleProps) => {
  let designSizes = {
    fontSize: 18,
    borderRadius: 5,
    paddingY: 10,
    paddingX: 12,
    marginBottom: 12,
  };

  if (mediaType !== 'mobile') {
    designSizes = {
      fontSize: 24,
      borderRadius: 8,
      paddingY: 12,
      paddingX: 24,
      marginBottom: 24,
    };

    const pcScale = 474 / 810;
    designSizes = mapValues(x => x * pcScale, designSizes);
  }

  const sizes = mapValues(x => x * scale, designSizes);

  const divStyle = {
    fontSize: sizes.fontSize,
    borderRadius: sizes.borderRadius,
    padding: `${sizes.paddingY}px ${sizes.paddingX}px`,
    marginBottom: sizes.marginBottom,
  };

  return (
    <div style={divStyle} className="proc-pizzaStaffTalkBubble gray100-color">
      {children}
    </div>
  );
});

const StaffTalkBubbleArrow = ({ scale }: { scale: number }) => {
  const style = {
    borderLeftWidth: 8 * scale,
    borderBottomWidth: 6 * scale,
    borderTopWidth: 8 * scale,
    marginBottom: 28 * scale,
  };

  return <div className="proc-pizzaStaffTalkBubble-arrow" style={style} />;
};

type OwnProps = {|
  message: ?string,
  showing?: boolean,
  scale?: number,
|};

type Props = {
  ...OwnProps,
  avatar: ?string,
};

const PizzaStaffInner = ({ message, showing = true, avatar, scale = 1 }: Props) => {
  const imgStyle = {
    width: 72 * scale,
    height: 90 * scale,
  };

  return (
    <TransitionGroup component={null}>
      {showing && (
        <CSSTransition key="pizza-staff" timeout={200} appear classNames="slidein">
          <TransitionGroup className="pizza-staff">
            {message && (
              <CSSTransition key="staff-line" timeout={200} classNames="slidein">
                <StaffTalkBubble scale={scale}>{message}</StaffTalkBubble>
              </CSSTransition>
            )}
            {message && (
              <CSSTransition key="staff-line-arrow" timeout={200} classNames="slidein">
                <StaffTalkBubbleArrow scale={scale} />
              </CSSTransition>
            )}
            <Transition timeout={0}>
              <div style={imgStyle} className={`pizza-staff-img pizza-staff-img--${avatar || 1}`} />
            </Transition>
          </TransitionGroup>
        </CSSTransition>
      )}
    </TransitionGroup>
  );
};

const mapStateToProps = (state: StoreState) => ({
  avatar: get(state, 'profile.avatar'),
});

export const PizzaStaff = connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(PizzaStaffInner);
